import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { VehicleGraphqlEntities } from 'client/data/models/vehicle-graphql';
import { CorePageParams } from 'site-modules/shared/utils/core-page/params';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { SubmodelDropdown } from './submodel-dropdown';
import { YearDropdown } from './year-dropdown';
import { ModelFamilyDropdown } from './model-family-dropdown';
import { TypeDropdown } from './type-dropdown';

import './year-submodel-controls.scss';

const DESCRIPTION_ID = 'year-submodel-description';

export function YearSubmodelControls({ params, vehicle, isPreprod = false }) {
  const selectedYearId = `${vehicle.modelYearId}`;
  const selectedSubmodelId = `${vehicle.year}|${vehicle.submodels.slug}`;
  const selectedModelSlug = `${vehicle.model.slug}`;
  const selectedType = `${vehicle.year}|${vehicle.make.slug}|${vehicle.model.slug}|${vehicle.submodels.slug}`;

  return (
    <div className="year-submodel-controls d-flex justify-content-between align-items-start">
      <span id={DESCRIPTION_ID} className="visually-hidden">
        Changing year or type will take you to a new page
      </span>
      <YearDropdown
        descriptionId={DESCRIPTION_ID}
        params={params}
        modelName={vehicle.model.name}
        value={selectedYearId}
        modelFamilyIds={vehicle?.modelFamilyIds}
      />
      {!isPreprod && (
        <FeatureFlag name="core-7707-type-dropdown">
          {enabled =>
            enabled ? (
              <TypeDropdown
                descriptionId={DESCRIPTION_ID}
                params={params}
                value={selectedType}
                skipModelFamily={params.isTruck}
                modelFamilyIds={vehicle.modelFamilyIds}
              />
            ) : (
              <Fragment>
                <SubmodelDropdown descriptionId={DESCRIPTION_ID} params={params} value={selectedSubmodelId} />
                {!params.isTruck && (
                  <ModelFamilyDropdown
                    descriptionId={DESCRIPTION_ID}
                    params={params}
                    value={selectedModelSlug}
                    modelFamilyIds={vehicle.modelFamilyIds}
                  />
                )}
              </Fragment>
            )
          }
        </FeatureFlag>
      )}
    </div>
  );
}

YearSubmodelControls.propTypes = {
  params: CorePageParams.isRequired,
  vehicle: VehicleGraphqlEntities.Vehicle.isRequired,
  isPreprod: PropTypes.bool,
};
